import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoveTo20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconMoveTo20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M4 3a1.5 1.5 0 0 1 1.5-1.5H8A1.5 1.5 0 0 1 9.5 3v1.5A1.5 1.5 0 0 1 8 6H5.5A1.5 1.5 0 0 1 4 4.5zm4 0H5.5v1.5H8zM5.5 7.75A1.5 1.5 0 0 0 4 9.25v1.5a1.5 1.5 0 0 0 1.5 1.5H8a1.5 1.5 0 0 0 1.5-1.5v-1.5A1.5 1.5 0 0 0 8 7.75zm0 1.5H8v1.5H5.5zm0 4.75A1.5 1.5 0 0 0 4 15.5V17a1.5 1.5 0 0 0 1.5 1.5H8A1.5 1.5 0 0 0 9.5 17v-1.5A1.5 1.5 0 0 0 8 14zm0 1.5H8V17H5.5zM11 7.75a.75.75 0 0 0 1.5 0V6c1.214.912 2 2.364 2 4a5 5 0 0 1-2 4v-1.75a.75.75 0 0 0-1.5 0v4.25h4.25a.75.75 0 0 0 0-1.5h-1.596A6.49 6.49 0 0 0 16 10c0-2.01-.913-3.808-2.346-5h1.596a.75.75 0 0 0 0-1.5H11z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconMoveTo20);
